export default __webpack_public_path__ + "static/media/pigeon.a0efc050.jpg";